import { buildTheme } from "../const"
import { setMuiColor } from "../const/baseTheme"

const ADH_BRANDING = setMuiColor({
  main: "#132339",
  // Dark
  dark1: "#101D30",
  dark2: "#0D1828",
  dark3: "#070D17",
  dark4: "#01070F",
  // Light
  light1: "#2761A2",
  light2: "#377EC0",
  light3: "#5D9BD3",
  light4: "#95BCE4",
})
const ADH_BRANDING_ACCENT = setMuiColor({
  main: "#4AC0EF",
  // Dark
  dark1: "#1BA5DE",
  dark2: "#0E85BD",
  dark3: "#0A6B99",
  dark4: "#035588",
  // Light
  light1: "#84D3F6",
  light2: "#BDE6FA",
  light3: "#E2F3FC",
  light4: "#F2F9FF",
})

export const adherentTheme = buildTheme(({ palette }) => ({
  palette: {
    branding: ADH_BRANDING,
    brandingAccent: ADH_BRANDING_ACCENT,
    header: {
      containedButton: {
        backgroundColor: "#385270",
        primaryColor: palette.common.white,
        secondaryColor: palette.common.white,
        hover: {
          backgroundColor: "#38527080",
        },
      },
      gradient: ADH_BRANDING.main,
    },
    background: {
      default: "#f7f7f7",
    },
    p3Components: {
      sideNavTitle: palette.primary.dark1,
    },
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          "&.header-menu .MuiTab-root:hover": {
            color: ADH_BRANDING_ACCENT.light3,
          },
          "&.header-menu .MuiTab-root.Mui-selected": {
            color: ADH_BRANDING_ACCENT.light3,
          },
          "&.header-menu .MuiTabs-indicator": {
            backgroundColor: ADH_BRANDING_ACCENT.main,
          },
        },
      },
    },
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       variants: [
    //         {
    //           props: { variant: "contained" },
    //           style: {
    //             color: palette.getContrastText(ADH_BRANDING.main),
    //             backgroundColor: ADH_BRANDING.main,
    //             "&:hover": {
    //               backgroundColor: ADH_BRANDING.dark3,
    //             },
    //           },
    //         },
    //         {
    //           props: { variant: "outlined" },
    //           style: {
    //             borderColor: ADH_BRANDING.main,
    //             color: ADH_BRANDING.main,
    //             "&:hover": {
    //               backgroundColor: ADH_BRANDING.main,
    //               color: palette.getContrastText(ADH_BRANDING.main),
    //             },
    //           },
    //         },
    //         {
    //           props: { variant: "text" },
    //           style: {
    //             color: ADH_BRANDING.main,
    //             "&:hover": {
    //               backgroundColor: `${ADH_BRANDING.main}5`,
    //             },
    //           },
    //         },
    //       ],
    //     },
    //   },
    // },
  },
}))
